import LocationDetailsPage from './LocationDetailsPage';
export default LocationDetailsPage;